import { server } from "./../../core/data/config";

export enum configGame {
    "CANVAS_WIDTH" = 1920,
    "CANVAS_HEIGHT" = 1080,
    "SPIN_TYPE" = 1,
    "SYMBOL_COUNT_MAX" = 8,
    "REEL_ROWS" = 6,
    "REEL_COLUMN" = 6,
    "REEL_HEIGHT" = 672,
    "REEL_CONTAINER_X" = 545,
    "REEL_CONTAINER_Y" = 121,
    "REEL_CONTAINER_X_IN_PORTRAIT" = 0,
    "REEL_CONTAINER_Y_IN_PORTRAIT" = 0,
    "REEL_CONTAINER_SCALE" = 1,
    "REEL_CONTAINER_SCALE_IN_PORTRAIT" = 0.5,
    "REEL_GRID_X" = 1,
    "REEL_GRID_Y" = 30,
    "REEL_GRID_X_IN_PORTRAIT" = -518,
    "REEL_GRID_Y_IN_PORTRAIT" = 132,
    "REEL_GRID_SCALE" = 1,
    "REEL_GRID_SCALE_IN_PORTRAIT" = 1.1,
    "REEL_WIDTH" = 138,
    "REEL_GAP" = 0,
    "SYMBOL_WIDTH" = 138,
    "SYMBOL_HEIGHT" = 138,
    "DISPLAY_ALL_WIN_DURATION" = 1,
    "TOGGLE_WIN_DURATION" = 1,
    "TOGGLE_WIN_DURATION_IDLE" = 1,
    "AUTOPLAY_UI_IN_CANVAS" = 0,
    "MENU_UI_IN_CANVAS" = 0,
    "HORIZONTAL_REEL_CONTAINER_X" = 1165,
    "HORIZONTAL_REEL_CONTAINER_Y" = 822,
    "HORIZONTAL_REEL_CONTAINER_X_IN_PORTRAIT" = 727,
    "HORIZONTAL_REEL_CONTAINER_Y_IN_PORTRAIT" = 397,
    "HORIZONTAL_REEL_CONTAINER_X_IN_LANDSCAPE" = 1166,
    "HORIZONTAL_REEL_CONTAINER_Y_IN_LANDSCAPE" = 830,
    "HORIZONTAL_REEL_CONTAINER_SCALE_IN_LANDSCAPE" = 1,
    "HORIZONTAL_REEL_CONTAINER_SCALE_IN_PORTRAIT" = 0.88,
    "HORIZONTAL_REEL_CONTAINER_X_ANIM_IN_PORTRAIT" = 886,
    "LANDING_ANIM_HIDE_DURATION" = 1000,
    "HORIZONTAL_REEL_CONTAINER_Y_ANIM_IN_PORTRAIT" = 315,
    "RANDOM_WILD_EFFECT_PORTRAIT_X" = 65,
    "RANDOM_WILD_EFFECT_PORTRAIT_Y" = 310,
    "GIANT_WILD_EFFECT_PORTRAIT_X" = 100,
    "GIANT_WILD_EFFECT_PORTRAIT_Y" = 255,
    
}

export const constant = {
    configGame: {
        "landscapeCanvasWidth": 1920,
        "landscapeCanvasHeight": 1080,
        "portraitCanvasWidth": 1080,
        "portraitCanvasHeight": 1920,
        "canvasWidth": 1920,
        "canvasHeight": 1080,
        "fillWindow": false,
        "fullscreen": false,
        "fullscreenMode": "FULLSCREEN_MODE_AUTO_PREFER_HEIGHT",
        "centered": true,
        "loaderBarWidth": 426,
        "loaderBarHeight": 31,
        "loaderBarX": 100, // +3
        "loaderBarY": 100,
        "loaderBarBGX": 84,
        "loaderBarBGY": 90,
        "loaderBarPortraitX": 100,
        "loaderBarPortraitY": -230,
        "loaderBarBGPortraitX": 90,
        "loaderBarBGPortraitY": -240,
        "showLoaderText": false,
        "langCode":"en",
        "currCode":"currCode",
        "cheatEnable":false,
        "buyInFeature_local":false,
        "buyInValue_local":"",
        "selection_local":"-1",
        "cheatModifiedRequest":"",
        "playerIdPostIntro":true,
        "playerId":"",
        "bridgeUrl":"",
    },
    reelgridConfig: {
        "LANDING_SYMBOL_ID_LIST": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
        //  "LANDING_SYMBOL_ID_LIST" : [],
        "ANTICIPATION_SYMBOL_LIST": ["SC"],
        "ANTICIPATION_TRIGGERING_SYMBOL_MIN_COUNT": 3,
        "ANTICIPATION_TRIGGERING_SYMBOL_MAX_COUNT": 4,
    },
   

    

    serverConfig: {
        endpoint: "http://88.208.244.42/f1x2games/IntegratedSlots",
        port: 0,
        method: "post",
        postfixpath: "",
        playerId:"",
      
        // "acc_id="+(window as any).GAME_INFO.acc_id +
        //     "&lang=" + (window as any).GAME_INFO.lang +
        //     "&gameID=" + (window as any).GAME_INFO.gameID +
        //     "&playMode=fun" +
        //     "&jurisdiction=null" +
        //     "&pathCDN=http%3A%2F%2Fwww.1x2-cloud-1.com%2Ff1x2games%2F" +
        //     "&dev=true&path=http%3A%2F%2F88.208.244.42%2Ff1x2games%2F" +
        //     "&clientName=1x2_dev" +
        //     "&installID=null" +
        //     "&folderName=" + (window as any).GAME_INFO.folderName +
        //     "&site=" + (window as any).GAME_INFO.site +
        //     "&gameType=" + (window as any).GAME_INFO.gameType +
        //     "&gameVersion=" + (window as any).GAME_INFO.gameVersion +
        //     "&version=" + (window as any).GAME_INFO.gameVersion +
        //     "&force=" + (window as any).GAME_INFO.force +
        //     "&fun_real=" + (window as any).GAME_INFO.fun_real +
        //     "&hash=259777413" +
        //     "&stake=100" +
        //     "&ex_rate=0.7167" +
        //     "&currency=EUR"
    }
}
function useQuery() {
    let search = window.location.search;

    return new URLSearchParams(search);
}

server.configGame.endpoint = "http://88.208.244.42/f1x2games/IntegratedSlots"
server.configGame.port = 0
server.configGame.method = "post"
